import { ChangeDetectionStrategy, Component, computed, effect, inject, signal } from '@angular/core';
import { S3uploaderService } from '../../services/s3uploader/s3uploader.service';

@Component({
  selector: 'atom-download-progress-toast',
  templateUrl: './download-progress-toast.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class DownloadProgressToastComponent {
  protected uploadService = inject(S3uploaderService);

  visible = signal(false);
  phase = signal<'downloading' | 'complete'>('downloading');

  progress = computed(() => {
    const total = this.uploadService.downloadContentLength();
    const loaded = this.uploadService.downloadContentProgress();
    return total > 0 ? Math.min(Math.round((loaded / total) * 100), 100) : 0;
  });

  constructor() {
    effect(() => {
      const active = this.uploadService.secureDownloadActive();
      if (active) {
        this.visible.set(true);
        this.phase.set('downloading');
      } else if (this.visible() && this.phase() === 'downloading') {
        this.phase.set('complete');
        setTimeout(() => this.visible.set(false), 3000);
      }
    });
  }

  dismiss() {
    this.visible.set(false);
  }
}
